import {inject} from 'aurelia-framework';  
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class VideoAPI {


    constructor(http){
        this.http = http;
    }
    
    

    getPublicVideosList(link_id, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json');
    
        });

        this.http.get('api/video/getPublicVideosList/' + link_id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("videos"))
                        successCallback(json.videos, json.org_name || null, json.website || null);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getFeaturedVideosList(link_id, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json');
    
        });

        this.http.get('api/video/getFeaturedVideosList/' + link_id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("videos"))
                        successCallback(json.videos, json.pubVideosCount);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    updateVideoReviewPageFavoriteCount(videoType, videoId, successCallback, errorCallback) {

        let data = {
            'video_type': videoType,
            'video_id': videoId
        };

        this.http = this.http.configure(x => {
          x.withHeader('Content-Type', 'application/json')
            // .withHeader('Authorization', token);
        });
    
      
    
    this.http.post('api/wlusers/updateVideoReviewPageFavoriteCount',JSON.stringify(data))
          .then(data => {
            if (data.isSuccess) {
    
                successCallback();
              
            } else {
    
              errorCallback(data.statusText);
              
            }
          });
    
      }
    

      updateReviewPageVideoPlayCount(videoType, videoId, successCallback, errorCallback) {

        let data = {
            'video_type': videoType,
            'video_id': videoId
        };

        this.http = this.http.configure(x => {
          x.withHeader('Content-Type', 'application/json')
            // .withHeader('Authorization', token);
        });
    
      
    
    this.http.post('api/wlusers/updateReviewPageVideoPlayCount',JSON.stringify(data))
          .then(data => {
            if (data.isSuccess) {
    
                successCallback();
              
            } else {
    
              errorCallback(data.statusText);
              
            }
          });
    
      }

    updateVideoCaptureFromSimpleCollectionPage(captureKey, successCallback, errorCallback) {

        let data = {
            'capture_key' : captureKey
        }
        this.http = this.http.configure(x => {
          x.withHeader('Content-Type', 'application/json')
        });
    
      
    
    this.http.post('api/wlusers/updateVideoCaptureFromSimpleCollectionPage',JSON.stringify(data))
          .then(data => {
            if (data.isSuccess) {
    
                successCallback();
              
            } else {
    
              errorCallback(data.statusText);
              
            }
          });
    
      }
    

}